import React, { useEffect, useState } from "react";

type SwitchProps = {
  items: string[];
  font?: string;
  onChange: (item: string) => void;
};

const getTextWidth = (text: string, font: string) => {
  // memoize canvas for better performance
  let canvas = null;

  if (!canvas) {
    canvas = document.createElement("canvas");
  }

  const context = canvas.getContext("2d");
  context.font = font;

  return context.measureText(text).width;
};

const Switch = ({ items, onChange, font }: SwitchProps) => {
  const [selected, setSelected] = useState<string>(items[0]);

  useEffect(() => {
    onChange(selected);
  }, [selected, onChange]);

  if (!items.length) return null;

  const selectedIndex = items.indexOf(selected);

  // font of .switch-item need to be the same value for indicator width calculation
  const itemsWidth = items.map(
    (item) => getTextWidth(item, font ?? "0.8rem Muli") + 32
  );

  const widthBeforeCurrentItem = itemsWidth
    .filter((_i, index) => index < selectedIndex)
    .reduce((sum, curr) => {
      let sumCopy = sum;
      sumCopy += curr;
      return sumCopy;
    }, 0);

  const indicatorStyles = {
    width: itemsWidth[selectedIndex],
    transform: `translateX(${widthBeforeCurrentItem}px)`,
  };

  const activeItemStyles = { color: "#FFF" };

  return (
    <div className="switch">
      <div className="switch-incidator" style={indicatorStyles} />
      {items.map((item, index) => (
        <div
          key={index}
          className="switch-item"
          style={item === selected ? activeItemStyles : undefined}
          onClick={item !== selected ? () => setSelected(item) : undefined}
          role="button"
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Switch;
